import api from "@/lib/api";

// Fire-and-forget funnel/analytics event. Never blocks the UI.
export function track(event, props = {}) {
  try {
    api.post("/track", { event, props }).catch(() => {});
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("ns:track", { detail: { event, props } }));
    }
  } catch { /* noop */ }
}
